<template>
   <div class="home">
      <div class="container bg-lightorange font-poppins">
         <div class="flex items-center">
            <div class="w-full items-center text-center justify-center">
               <div
                  class="font-bold text-4xl bg-gradient-to-r bg-clip-text text-transparent from-sky-600 to-darkblue">
                  Let's reading Qur'an.
               </div>
               <blockquote
                  class="font-medium text-center italic text-white my-3">
                  "<b>Al-Quran</b> adalah firman atau kalam yang berasal dari
                  <b>Allah</b> yang diwahyukan kepada Rasulullah
                  <b>Muhammad</b> dengan perantara melalui malaikat Jibril
                  sebagai penyempurna kitab-kitab terdahulu dan menjadi pedoman
                  serta petunjuk seluruh umat manusia."
               </blockquote>
               <router-link
                  to="/"
                  class="btn-primary transition duration-300 ease-in-out hover:shadow-lg"
                  >Read now</router-link
               >
            </div>

            <div class="w-full flex justify-end">
               <img
                  :src="`../../assets/images/jungle-remote-working-3.png`"
                  alt="hero" />
            </div>
         </div>
      </div>

      <div class="container flex justify-center items-center">
         <div class="flex w-1/2 sm:w-full">
            <img
               :src="`../../assets/images/jungle-searching-1.png`"
               alt="hero" />
         </div>
         <div class="sm:w-full w-1/2">
            <h4 class="text-white font-semibold mb-3">
               Keutamaan membaca alqur'an:
            </h4>
            <div class="px-4 py-2 transparent-card">
               <ul class="max-w-md space-y-1 text-darkblue list-inside">
                  <li class="flex items-center">
                     <svg
                        class="w-4 h-4 mr-1.5 text-orange flex-shrink-0"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                           fill-rule="evenodd"
                           d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                           clip-rule="evenodd"></path>
                     </svg>
                     Mendatangkan rahmat dari Allah SWT dan mendapatkan
                     perlindungan
                  </li>
                  <li class="flex items-center">
                     <svg
                        class="w-4 h-4 mr-1.5 text-orange flex-shrink-0"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                           fill-rule="evenodd"
                           d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                           clip-rule="evenodd"></path>
                     </svg>
                     mendatangkan kebaikan dan kemuliaan
                  </li>
                  <li class="flex items-center">
                     <svg
                        class="w-4 h-4 mr-1.5 text-orange flex-shrink-0"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                           fill-rule="evenodd"
                           d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                           clip-rule="evenodd"></path>
                     </svg>
                     Sebagai penyembuh penyakit pada tubuh
                  </li>
               </ul>
            </div>
         </div>
      </div>

      <div class="container">
         <h4 class="text-darkblue font-semibold text-2xl my-2">Daftar Surah</h4>
      </div>
      <div class="container">
         <div v-if="loading">
            <div
               class="flex justify-center items-center min-h-screen bg-transparent">
               <div
                  class="h-3 w-3 animate-ping rounded-full bg-white/50 opacity-75"></div>
            </div>
         </div>

         <div v-else>
            <div class="container">
               <div
                  class="grid lg:grid-cols-4 gap-4 sm:grid-cols-1 md:grid-cols-2">
                  <div v-for="surah in surahs" :key="surah.id">
                     <Card :surah="surah" />
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import Card from "@/components/Card.vue";
import axios from "axios";

export default {
   name: "HomePage",
   components: { Card },

   data() {
      return {
         surahs: [],
         loading: false,
      };
   },
   methods: {
      getSurah() {
         this.loading = true;
         axios
            .get(`https://api.npoint.io/99c279bb173a6e28359c/data`)
            .then((res) => {
               this.surahs = res.data;
               this.loading = false;
            })
            .catch((e) => (console.log(e), (this.isloading = false)));
      },
   },
   mounted() {
      this.getSurah();
   },
};
</script>

<style></style>
